import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { getPaginatedNodes } from './utils';
import { GetUploadFoldersQuery } from '../gql/graphql';
import { FirstPaginationNode } from './types';

const GET_UPLOAD_FOLDERS = graphql(`
  query getUploadFolders {
    uploadFolders {
      pageInfo {
        totalResults
        hasNextPage
        pageNumber
      }
      edges {
        node {
          name
        }
      }
    }
  }
`);

export function useUploadFoldersQuery() {
  const { loading, error, data } = useQuery(GET_UPLOAD_FOLDERS, {});

  const uploadFolders = useMemo(() => {
    const uploadFolders = getPaginatedNodes(data?.uploadFolders);

    return uploadFolders;
  }, [data]);

  return {
    loading,
    error,
    data,
    uploadFolders,
  };
}

export type UploadFolderDetails = FirstPaginationNode<
  GetUploadFoldersQuery['uploadFolders']
>;
